<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="download">
                <div class="image">
                    <img :src="image" alt="" width="206px" height="206px">
                </div>
                <div class="text">
                    <p>更多信息请下载APP访问</p>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import {app} from "../api/index"
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
export default {
    components: {
        top,
        bottom,
    navs
    },
    data(){
        return{
            image:""
        }
    },
    created(){
        app().then(res=>{
            this.image = res.data.data.image1
            console.log(this.image)

        })
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}
.content{
    width: 100%;
    height: 480px;
    background-image: url(../image/back.png);
    display: flex;
    align-items: center;
    justify-content: center;
}
.download{
    width: 70%;
    height: 372px;
    background-color: #F7F7F7;
    display: flex;
}
.image{
    width: 30%;
    height: 372px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.text{
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 17px;
color: #333333;
line-height: .2125rem;
text-align: right;
font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/views/Download.vue